import React from 'react';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import { connect } from '../../utils';


const IconButtonView = (props) => {
  const {id,layoutState} = props;
  const { buttonColors, tooltipPosition, tooltip, icon, size, href, buttonAlign , disabled, containerPadding} = layoutState.getItemJS(id).props.values;
  
   
  return (
    <div style={{
      boxSizing: 'border-box',
      position: 'relative',
      height: 'auto',
      display: 'flex',
      width:'100%',
      justifyContent: buttonAlign,
      flex:1,
      padding: containerPadding
    }}>
      <IconButton
        disabled={disabled}
        iconStyle={checkStylesIcon(size)}
        style={checkStyles(size, buttonColors.backgroundColor)}
        tooltip={tooltip}
        tooltipPosition={tooltipPosition}
        href={href.url}
        target={href.target}
       >
        <FontIcon className="material-icons" style={{fill:buttonColors.color, color: buttonColors.color}} 	color={buttonColors.color} hoverColor={buttonColors.hoverColor}> {icon} </FontIcon>
      </IconButton>
    </div>
  );
}

const checkStyles = (size, color) => {
  let  iconS = {
    borderRadius:'50%',
    backgroundColor: color
  };
  if (size === 'large') {
    iconS.width= 120;
    iconS.height = 120;
    iconS.padding = 30;
  } else if (size === 'medium') {
    iconS.width= 96;
    iconS.height = 96;
    iconS.padding = 24;
  }  else if (size === 'small') {
    iconS.width= 72;
    iconS.height = 72;
    iconS.padding = 16;
  }
  return iconS;
}
const checkStylesIcon = (size) => {
  let  iconS = styles.xsmallIcon;
  if (size === 'large') {
    iconS = styles.largeIcon;
  } else if (size === 'medium') {
    iconS = styles.mediumIcon;
  }  else if (size === 'small') {
    iconS = styles.smallIcon;
  }
  return iconS;
}

const styles = {
  xsmallIcon: {
    fontSize: 24,
  },
  smallIcon: {
    width: 36,
    height: 36,
    fontSize: 36,
  },
  mediumIcon: {
    width: 48,
    height: 48,
    fontSize: 48,
  },
  largeIcon: {
    width: 60,
    height: 60,
    fontSize: 60,
  }, 
};

export default connect('layoutState')(IconButtonView);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/IconButtonView.js